const styles = {
  root: {
    backgroundColor: 'background.default',
    mb: 1,
    '&.bg-gray': {
      backgroundColor: 'background.main',
    },
  },

}

export default styles
